import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { SITE_NAME, SITE_URL, SITEMAP_LASTMOD } from '../../../constants/siteSeo';

/** 交通IC・共用カード公開ページ向け JSON-LD（BreadcrumbList + SoftwareApplication） */
export default function TransitPassPoolPageStructuredData() {
  const { t } = useTranslation();
  const pageUrl = `${SITE_URL}/transit-pass-pool`;
  const description = t('tpp.page_meta_description');
  const name = t('tpp.page_meta_title');
  const keywords = t('tpp.page_meta_keywords', { defaultValue: '' });

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${pageUrl}#webpage`,
        url: pageUrl,
        name,
        description,
        dateModified: SITEMAP_LASTMOD,
        isPartOf: { '@id': `${SITE_URL}/#website` },
        about: { '@id': `${pageUrl}#software` },
        mainEntity: { '@id': `${pageUrl}#software` },
      },
      {
        '@type': 'SoftwareApplication',
        '@id': `${pageUrl}#software`,
        name: t('tpp.title', { defaultValue: 'Transit IC pool' }),
        alternateName: ['Transit Pass Pool', '交通IC', '交通系IC・共用カード'],
        url: pageUrl,
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'Web',
        description,
        isAccessibleForFree: true,
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'JPY',
        },
        author: { '@id': `${SITE_URL}/#developer` },
        publisher: { '@id': `${SITE_URL}/#developer` },
        ...(keywords ? { keywords } : {}),
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: SITE_NAME,
            item: SITE_URL,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: t('tpp.title', { defaultValue: 'Transit IC pool' }),
            item: pageUrl,
          },
        ],
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
